import React, { Component } from 'react'
import {axisLeft} from 'd3-axis';
import {format} from "d3-format";
import {select} from 'd3-selection';

class YearYAxis extends Component {

  renderAxis() {
    const {formatters, y, svg_width, margins, active_mode} = this.props;
    var yAxis = axisLeft()
      .scale(y)
      .ticks(5)
      .tickSize(- svg_width + margins.right, 0 ,0)
    if (active_mode === 'Price') {
      yAxis.tickFormat(format('$.1s'))
    } else {
      yAxis.tickFormat(format('.0%'))
    }
    const node = this.refs.axis;
    const axis = select(node).call(yAxis)
    axis.selectAll("text")
      .attr("x", -4)
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  render() {
    const {margins} = this.props;
    return (
      <g className="Axis" ref="axis" transform={`translate(0,0)`}>
      </g>
    )
  }
}

export default YearYAxis;



/** WEBPACK FOOTER **
 ** ./src/components/YearYAxis.js
 **/